import { strReplace } from "../lib/helper-support";
import OptionType from "../types/option-type";

const CustomOptions = (options: string[]) => {
    return options.map((item: any) => ({value: item, name:  strReplace(item, '_', ' ')} as OptionType));
}

export { 
    CustomOptions,
};